import React, {useEffect, useRef, useState, useCallback} from "react"
import {LocalPlayer as LP} from "../../lib/LocalPlayer.js";
import {YoutubePlayer as YTP} from "../../lib/YoutubePlayer.js";
import Player from "../../lib/Player.ts";
import PlayerState from "../../lib/PlayerState.ts";
// @ts-ignore
import {LoopControl} from "../ControlCluster/LoopControl.tsx";
import {Speed} from "../ControlCluster/SpeedControl.js";
import {PitchControl} from "../ControlCluster/PitchControl.js";
import {Zoom} from "../ControlCluster/ZoomControl.js";
import {LoopShed} from "../ControlCluster/LoopShed.js";
import {Playback} from "../ControlCluster/Playback.tsx";
import {Loops} from "../ControlCluster/Loops";
import {PlayerProvider} from "../../Context/PlayerContext.tsx";
import HashDAO, {HashValue} from "../../lib/hashDAO.ts";

function LocalPlayer({mediaID, playerType, mediaName}) {

    const rawPlayer = useRef(null);

    const [playerState, setPlayerState] = useState(new PlayerState())

    const playerStateCallback = (playerState: PlayerState) => {
        let ps = PlayerState.fromPlayerState(playerState)
        setPlayerState(ps)
        window.location.hash = HashDAO.generateHashFromState(ps)
    }

    if (mediaName === undefined) {
        mediaName = mediaID
    }

    useEffect(() => {
        // if type is youtube, use the YoutubePlayer, otherwise use the LocalPlayer
        // set the hash to the current player type and mediaID
        let hv = HashDAO.getHashValues()


        if (playerType === "youtube") {
            rawPlayer.current = new YTP("#waveform", mediaID, playerStateCallback)
            hv.playerType = "youtube"
            hv.mediaID = mediaID
        } else {
            rawPlayer.current = new LP("#waveform", mediaID, playerStateCallback)
            hv.playerType = "local"
            hv.mediaID = mediaID
        }
        if (hv.loops.length >= 1){
            console.log("setting loops", hv.loops)
            let ps = rawPlayer.current.playerState;
            ps.setLoops(hv.loops, 0)
        }

        window.location.hash = HashDAO.generateHashValues(hv)
        return () => {
            rawPlayer.current.destroy()
        }
    }, [mediaID, playerType]);

    useEffect(() => {
        //handle and destroy for resizing
        const handleResize = () => {
            rawPlayer.current.redraw();
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Use useEffect to set up an event listener for hash changes
    useEffect(() => {
        const handleHashChange = () => {
            // Update the state based on the new hash value
            let hash = window.location.hash
        };

        // Attach the hashchange event listener
        window.addEventListener('hashchange', handleHashChange);

        // Cleanup by removing the event listener when the component unmounts
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    // const proxy = (func, ...args) => {
    //     //console.log("proxy", func, args)
    //     rawPlayer.current[func](...args)
    // }
    const proxy = useCallback((func, ...args) => {
        console.log("proxy called", func, args, "rawPlayer.current:", rawPlayer.current);
        if (rawPlayer.current && typeof rawPlayer.current[func] === 'function') {
            rawPlayer.current[func](...args);
        }
    }, []);


    return (
        <PlayerProvider player={rawPlayer.current} playerState={playerState}>
            {/*style={{width:"768px", margin: "auto"}}*/}
            {playerType === "local" && <div>
                <div className="d-flex flex-column align-items-center">
                    <h3 className={"ml-5 mt-1 mb-1 d-lg-none"}>{mediaName}</h3>

                    <div className={"d-flex justify-content-between flex-column flex-md-row align-items-center"}>
                        <div className={"col-lg-2 col-md-6 col-sm-12"}>
                            <PitchControl showHeader={false} playerState={playerState} proxy={proxy}/>
                        </div>
                        <h3 className={"ml-5 mt-1 mb-1 d-none d-lg-block"}>{mediaName}</h3>
                        <div className={"col-lg-2 col-md-6 col-sm-12"}>
                            <Zoom showHeader={false} playerState={playerState} proxy={proxy}/>
                        </div>
                    </div>
                </div>

                <div id={"waveform"} className="w-100"/>
                <div id={"tl"} className="w-100"/>
                <div id={"mm"} className="w-100"/>
                <div style={{"height": "10px"}}></div>
            </div>
            }
            {playerType === "youtube" && <div>

                <div className={"d-flex flex-row justify-content-lg-between justify-content-md-center align-items-lg-end"}>
                    <div className={"col-lg-2 col-md-6 d-none d-lg-block"}>
                        <PitchControl showHeader={false} playerState={playerState} proxy={proxy}/>
                    </div>
                    <div id="ytplayer" ></div>
                    <div className={"col-lg-2 col-md-6 d-none d-lg-block"}>
                        <Zoom showHeader={false} playerState={playerState} proxy={proxy}/>
                    </div>
                </div>

                <div className={"d-flex flex-row justify-content-between d-lg-none bg-light"}>
                    <div className={"col-6"}>
                        <PitchControl showHeader={false} playerState={playerState} proxy={proxy}/>
                    </div>
                    <div className={"col-6"}>
                        <Zoom showHeader={false} playerState={playerState} proxy={proxy}/>
                    </div>
                </div>

                <div id={"waveform"} className={""}></div>
                <div id={"tl"}></div>
            </div>
            }


            <div className={"d-block d-md-none " + (playerType === "youtube" ? "mt-2" : "")} >
                {/*<p>sm</p>*/}
                <div className={"d-flex flex-column"}>
                    <div className={"d-flex flex-row align-items-start justify-content-between"}>
                        <div className={"d-flex flex-column col-12"}>
                            <div className={"d-flex justify-content-start align-items-center"}>
                                <div className={""}>
                                    <Playback showHeader={false} playerState={playerState} proxy={proxy}/>
                                </div>
                                <div className={""}>
                                    <LoopControl showHeader={false} playerState={playerState} proxy={proxy}/>
                                </div>
                            </div>
                            <div >
                                <Loops/>
                            </div>
                            <div className={""}>
                                <Speed showHeader={false} playerState={playerState} proxy={proxy}/>
                            </div>
                            <div className={"col-12"}>
                                <LoopShed showHeader={false} playerState={playerState} proxy={proxy}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"d-none d-md-block  " + (playerType === "youtube" ? "mt-2" : "")}>
                {/*<p>md and up</p>*/}
                <div className={"d-flex flex-column"}>
                    <div className={"d-flex flex-row align-items-start justify-content-between"}>
                        <div className={"d-flex flex-column col-6 col-lg-8"}>
                            <div className={"d-flex justify-content-start align-items-start ms-1"}>
                                <div className={""}>
                                    <Playback showHeader={false} playerState={playerState} proxy={proxy}/>
                                </div>
                                <div className={""}>
                                    <LoopControl showHeader={false} playerState={playerState} proxy={proxy}/>
                                </div>
                                <div className={"col-lg-4"}>
                                    <Loops/>
                                </div>
                            </div>
                            <div className={"col-lg-4"}>
                                <Speed showHeader={false} playerState={playerState} proxy={proxy}/>
                            </div>
                        </div>
                        <div className={"col-6 col-lg-4"}>
                            <LoopShed showHeader={false} playerState={playerState} proxy={proxy}/>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{height: "100px"}}></div>
        </PlayerProvider>
    )
}

export default LocalPlayer;
